import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { AttachFile } from "@mui/icons-material";

import { CertificateDto } from "../../interfaces/CertificateDto";
import { dateToStringShort } from "../../common/utils/dateTime";
import SectionPreview from "../../common/components/SectionPreview";

type CertificatesHistoryProps = {
  certificates?: Array<CertificateDto>;
};

export default function CertificatesHistory({ certificates }: CertificatesHistoryProps) {
  const render = () => {
    return (
      <SectionPreview title="Данни за потребителските сертификати">
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell width="40%">SHA-1 на публичния ключ (на електронния подпис)</TableCell>
                <TableCell width="20%">Валиден от</TableCell>
                <TableCell width="20%">Валиден до</TableCell>
                <TableCell width="230px"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {certificates?.map((certificate) => (
                <TableRow key={certificate.thumbprint} hover>
                  <TableCell height="60px">{certificate.thumbprint}</TableCell>
                  <TableCell>{dateToStringShort(certificate.validFrom)}</TableCell>
                  <TableCell>{dateToStringShort(certificate.validTo)}</TableCell>
                  <TableCell>
                    {certificate.hasContent && (
                      <Button
                        startIcon={<AttachFile />}
                        variant="outlined"
                        href={`${process.env.REACT_APP_API_URL}/user/download/certificate/${certificate.thumbprint}`}
                      >
                        Изтегли сертификат
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </SectionPreview>
    );
  };

  return certificates && certificates.length > 0 ? render() : null;
}
